import { z } from "zod";

const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export const CreateUserSchema = z.object({
    email: z
        .string()
        .min(1, "Email is required.")
        .email("Please enter a valid email address."),
    full_name: z.string().min(1, "Full name cannot be empty."),
    password: z
        .string()
        .min(8, "Password must be at least 8 characters long.")
        .regex(
            passwordRegex,
            "Password must include uppercase, lowercase, number, and special character.",
        )
        .optional(),
    phone_number: z.string().min(1, "Phone number is required."),
    roles: z
        .union([z.string(), z.array(z.string())])
        .transform((val) => (typeof val === "string" ? [val] : val))
        .refine((arr) => arr.length > 0, "At least one role must be selected."),
    is_admin: z.boolean(),
    direct_permissions: z.array(z.string()),
    assigned_employee_id: z.string().min(1, "AR Coordinator name is requied"),
});

export const UserFormSchemaWithoutRefine = CreateUserSchema.extend({
    confirmPassword: z
        .string()
        .min(8, "Please confirm your password.")
        .optional(),
});

export const UserFormSchema = CreateUserSchema.extend({
    confirmPassword: z
        .string()
        .min(8, "Please confirm your password.")
        .optional(),
}).refine((data) => data.password === data.confirmPassword, {
    path: ["confirmPassword"],
    message: "Passwords do not match.",
});

export const UpdateUserSchema = CreateUserSchema.omit({
    password: true,
});

export type UserFormSchema = z.infer<typeof UserFormSchema>;
export type CreateUserSchema = z.infer<typeof CreateUserSchema>;
export type UpdateUserSchema = z.infer<typeof UpdateUserSchema>;

export const UpdatePasswordSchemaWithoutRefine = z.object({
    password: z
        .string()
        .min(8, "Password must be at least 8 characters long.")
        .regex(
            passwordRegex,
            "Password must include uppercase, lowercase, number, and special character.",
        ),

    confirmPassword: z.string().min(8, "Please confirm your password."),
});

export const UpdatePasswordSchema = UpdatePasswordSchemaWithoutRefine.refine(
    (data) => data.password === data.confirmPassword,
    {
        path: ["confirmPassword"],
        message: "Passwords do not match.",
    },
);

export type UpdatePasswordSchema = z.infer<typeof UpdatePasswordSchema>;
